


// case 'devd23':
    // export const baseUrl = 'https://uataskai.tataplay.com/recharge-dev';


//   case 'dev1':
    //  export const baseUrl = 'https://uataskai.tataplay.com/dev1';
 
//   case 'dev2':
    // export const baseUrl = 'https://uataskai.tataplay.com/dev2';

//   case 'dev3':
    // export const baseUrl = 'https://uataskai.tataplay.com/dev3';

//   case 'dev4':
    // export const baseUrl = 'https://uataskai.tataplay.com/dev4';
   
//   case 'UAT':
    // export const baseUrl = 'https://uataskai.tataplay.com/recharge';

//   case 'beta':
    // export const baseUrl = 'https://askai.tataplay.com/beta';
  
//   case 'prod':
    export const baseUrl = 'https://askai.tataplay.com/recharge';
   

// urlConfig.js

// let baseUrl;

// switch (process.env.REACT_APP_ENV) {

//   case 'dev1':
//     baseUrl = 'https://uataskai.tataplay.com/recharge-dev';
//   case 'dev2':
//     baseUrl = 'https://uataskai.tataplay.com/dev2';
//     break;
//   case 'dev3':
//     baseUrl = 'https://uataskai.tataplay.com/dev3';
//     break;
//   case 'dev4':
//     baseUrl = 'https://uataskai.tataplay.com/dev4';
//     break;
//   case 'UAT':
//     baseUrl = 'https://uataskai.tataplay.com/recharge';
//     break;
//   case 'beta':
//     baseUrl = 'https://askai.tataplay.com/beta';
//     break;
//   case 'prod':
//     baseUrl = 'https://askai.tataplay.com/recharge';
//     break;
//   default:
//     baseUrl = 'https://uataskai.tataplay.com/recharge';   // Default UAT
// }

// export { baseUrl };
